var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card__container"},[_c('div',{staticClass:"card__header"},[_c('h2',[_vm._v(_vm._s(_vm.$t(_vm.title)))]),_c('p',[_vm._v(_vm._s(_vm.$t(_vm.text)))]),_c('v-button',{staticClass:"button--tn-main",attrs:{"text":_vm.$t('contact-us'),"fit-content":"","to":{name: 'contact'}}})],1),_c('div',{staticClass:"card__body"},[_c('v-img',{attrs:{"width":"480","height":"200","src":"/v-images/ContactUsCard.jpg","webp-src":"/v-images/ContactUsCard.webp","alt":_vm.$t(_vm.title),"responsive":[
          {id: 1, maxW: 1024, minW: 520,
           src: '/v-images/ContactUsCard@1024.jpg',
           webpSrc: '/v-images/ContactUsCard@1024.webp'
          },
          {id: 2, maxW: 520, minW: 240,
           src: '/v-images/ContactUsCard@576.jpg',
           webpSrc: '/v-images/ContactUsCard@576.webp'
          } ],"is-lazy-load":false}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }